var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setHasFinishedSignup } from '@popup/multichain/actions/has-finished-signup.actions';
import { forgetMk } from '@popup/multichain/actions/mk.actions';
import { goBack, navigateTo, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { resetAccount } from '@popup/steem/actions/account.actions';
import { resetActiveAccount } from '@popup/steem/actions/active-account.actions';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const ClearAllData = ({ setTitleContainerProperties, navigateTo, goBack, resetAccount, forgetMk, resetActiveAccount, setHasFinishedSignup, }) => {
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_clear',
            isBackButtonEnabled: true,
        });
    }, []);
    const reset = () => __awaiter(void 0, void 0, void 0, function* () {
        resetAccount();
        forgetMk();
        setHasFinishedSignup(false);
        resetActiveAccount();
        yield LocalStorageUtils.clearLocalStorage();
        navigateTo(Screen.SIGN_UP_PAGE, true);
    });
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_CLEAR_ALL_DATA}-page`, className: "clear-all-data-page" },
        React.createElement("p", { className: "introduction", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_clear_all_data_desc'),
            } }),
        React.createElement("div", { className: "bottom-panel" },
            React.createElement(ButtonComponent, { dataTestId: "dialog_cancel-button", label: 'dialog_cancel', onClick: goBack, type: ButtonType.ALTERNATIVE }),
            React.createElement(ButtonComponent, { dataTestId: "dialog_confirm-button", label: 'popup_html_confirm', onClick: () => reset(), type: ButtonType.IMPORTANT }))));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
    navigateTo,
    goBack,
    resetAccount,
    forgetMk,
    resetActiveAccount,
    setHasFinishedSignup,
});
export const ClearAllDataComponent = connector(ClearAllData);
